import { createElement } from 'react'
import { Navigate } from 'react-router'
import isArray from 'lodash-es/isArray'
import isFunction from 'lodash-es/isFunction'

import { getLibraryPagePath, LIBRARY_MENU } from '../components/Library'
import { EMPTY_LIST, EMPTY_STRING } from '../constants/common'
import { isEmptyString } from '../utils/common'

function createRoutes(routes, items, parent = EMPTY_LIST) {
  items.forEach(([title, element]) => {
    const path = getLibraryPagePath(title)

    const fullPath = isEmptyString(path) ? parent : [...parent, path]
    const isFolder = isArray(element)

    routes.push({
      element: isFolder ? (
        <Navigate replace to={element[0][0]} />
      ) : isFunction(element) ? (
        createElement(element)
      ) : (
        element
      ),
      path: fullPath.join('/'),
    })

    if (isFolder) {
      routes.push(...createRoutes([], element, fullPath))
    }
  })

  return routes
}

export const libraryRoutes = createRoutes([], [[EMPTY_STRING, LIBRARY_MENU]])
